module.exports = __webpack_public_path__ + "static/media/kaple-varhany.285213e1.jpg";